import { css } from 'styled-components';
import {
  BASE_IMAGE_WIDTH,
  LARGE_IMAGE_WIDTH,
  SMALL_IMAGE_WIDTH,
  PRICE_WIDTH_LARGE,
  PRICE_WIDTH_SMALL,
} from '@/app/components/search/components/EvolutionCard/constants.ts';

export const CARD_CONTAINER_MIN_MAP_WIDTH = '768px';
export const CARD_CONTAINER_MIN_LIST_WIDTH = '1068px';

export const smallImageStyle = (styles: ReturnType<typeof css>) => css`
  @media (min-width: 768px) {
    @container cards-grid not (min-width: ${CARD_CONTAINER_MIN_MAP_WIDTH}) {
      ${styles};
    }
  }
`;

export const imageWidthStyle = css`
  // fallback without container queries
  @media (min-width: 768px) {
    width: ${BASE_IMAGE_WIDTH};
  }

  @media (min-width: 1440px) {
    width: ${LARGE_IMAGE_WIDTH};
  }

  //  container queries
  @media (min-width: 768px) {
    @container cards-grid (min-width: ${CARD_CONTAINER_MIN_MAP_WIDTH}) {
      width: ${BASE_IMAGE_WIDTH};
    }

    @container cards-grid (min-width: ${CARD_CONTAINER_MIN_LIST_WIDTH}) {
      width: ${LARGE_IMAGE_WIDTH};
    }
  }

  ${smallImageStyle(css`
    width: ${SMALL_IMAGE_WIDTH};
  `)}
`;

export const imageWidthCalcStyle = css`
  // fallback without container queries
  @media (min-width: 768px) {
    width: calc(100% - ${BASE_IMAGE_WIDTH});
  }

  @media (min-width: 1440px) {
    width: calc(100% - ${LARGE_IMAGE_WIDTH});
  }

  //  container queries
  @media (min-width: 768px) {
    @container cards-grid (min-width: ${CARD_CONTAINER_MIN_MAP_WIDTH}) {
      width: calc(100% - ${BASE_IMAGE_WIDTH});
    }

    @container cards-grid (min-width: ${CARD_CONTAINER_MIN_LIST_WIDTH}) {
      width: calc(100% - ${LARGE_IMAGE_WIDTH});
    }
  }

  ${smallImageStyle(css`
    width: calc(100% - ${SMALL_IMAGE_WIDTH});
  `)}
`;

export const priceContainerWidthStyle = css`
  // fallback without container queries
  @media (min-width: 768px) {
    width: ${PRICE_WIDTH_SMALL};
  }

  @media (min-width: 1440px) {
    width: ${PRICE_WIDTH_LARGE};
  }

  //  container queries
  @media (min-width: 768px) {
    @container cards-grid (min-width: ${CARD_CONTAINER_MIN_MAP_WIDTH}) {
      width: ${PRICE_WIDTH_SMALL};
    }

    @container cards-grid (min-width: ${CARD_CONTAINER_MIN_LIST_WIDTH}) {
      width: ${PRICE_WIDTH_LARGE};
    }
  }
`;

export const priceContainerWidthCalcStyle = css`
  // fallback without container queries
  @media (min-width: 768px) {
    width: calc(100% - ${PRICE_WIDTH_SMALL});
  }

  @media (min-width: 1440px) {
    width: calc(100% - ${PRICE_WIDTH_LARGE});
  }

  //  container queries
  @media (min-width: 768px) {
    @container cards-grid (min-width: ${CARD_CONTAINER_MIN_MAP_WIDTH}) {
      width: calc(100% - ${PRICE_WIDTH_SMALL});
    }

    @container cards-grid (min-width: ${CARD_CONTAINER_MIN_LIST_WIDTH}) {
      width: calc(100% - ${PRICE_WIDTH_LARGE});
    }
  }
`;
